/**
 * PageHeader — shared page header for all dashboard surfaces (Phase 1).
 *
 * Pattern locked in heymotek-web preview pages:
 *   <h1 text-3xl/4xl/5xl extrabold tracking-tight text-dark>
 *   <p text-base/lg text-muted-foreground (the subtitle)
 *   right-aligned action slot (optional)
 *
 * Brand sheet typography scale §4.
 */

import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function PageHeader({
  title,
  subtitle,
  action,
  className,
}: PageHeaderProps) {
  return (
    <div
      className={`mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between ${className ?? ''}`}
    >
      <div>
        <h1 className="text-3xl font-extrabold tracking-tight text-dark sm:text-4xl lg:text-5xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-2 text-base text-muted-foreground">
            {subtitle}
          </p>
        )}
      </div>
      {action && (
        <div className="shrink-0 self-start sm:self-auto">{action}</div>
      )}
    </div>
  );
}
